import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { ApiResponse } from '@typings/ApiResponse';
import { monthlyShareNOK } from '@api/analytics';
import { MonthlyShareNOK } from '@typings/Analytics';
import { ShareNOKChartData } from '../../types';

interface MonthlyChartProps {
  partnerCarehomeId: string;
}

const MonthlyChart: React.FC<MonthlyChartProps> = ({ partnerCarehomeId }) => {
  const [monthlyData, setMonthlyData] = useState<ShareNOKChartData[]>();
  useEffect(() => {
    const getMonthlyData = async () => {
      try {
        const res: ApiResponse<MonthlyShareNOK[]> =
          await monthlyShareNOK(partnerCarehomeId);
        if (res?.data) {
          const transformedData = res.data.map(item => {
            const { year, month, nextOfKin, total } = item;
            const formattedDate = dayjs(`${year}-${month}-01`).format(
              'MMM YYYY'
            );
            return {
              name: formattedDate,
              Shared: nextOfKin,
              'Not shared': total - nextOfKin,
            };
          });
          setMonthlyData(transformedData);
        }
      } catch (error) {
        console.error('Error fetching monthly data:', error);
      }
    };
    if (partnerCarehomeId) {
      getMonthlyData();
    }
  }, [partnerCarehomeId]);

  return (
    <div className="mb-10">
      <h3 className="govuk-heading-s chart-title">Monthly (last 12 months)</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={monthlyData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Shared" stackId="a" fill="#005eb8" />
          <Bar dataKey="Not shared" stackId="a" fill="#d4351c" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MonthlyChart;
